import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "p-6"
};
const _hoisted_2 = {
  key: 0,
  class: "mb-4 p-3 bg-slate-50 rounded-lg"
};
const _hoisted_3 = {
  class: "text-sm text-slate-600 line-clamp-2"
};
const _hoisted_4 = {
  class: "text-xs text-slate-400 mt-1"
};
const _hoisted_5 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_6 = ["disabled"];
import { ref } from 'vue';
import UserSelector from '@/components/UserSelector/index.vue';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'DemandAssignModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: null
    }
  },
  emits: ['update:show', 'confirm'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const selectedUserId = ref(null);
    const loading = ref(false);
    const handleConfirm = () => {
      if (!selectedUserId.value) return;
      loading.value = true;
      emit('confirm', {
        demandId: props.item?.id,
        handlerId: selectedUserId.value
      });
    };
    const handleClose = () => {
      selectedUserId.value = null;
      loading.value = false;
      emit('update:show', false);
    };

    // 父组件调用，分配完成后关闭
    const done = () => {
      loading.value = false;
      handleClose();
    };
    __expose({
      done
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: __props.show,
          size: "md",
          "panel-class": "mx-4",
          onClose: handleClose
        }, {
          default: _withCtx(() => [_cache[2] || (_cache[2] = _createElementVNode("div", {
            class: "px-6 py-4 border-b border-slate-200"
          }, [_createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "分配需求"), _createElementVNode("p", {
            class: "text-sm text-slate-500 mt-1"
          }, "选择一个处理人来负责此需求")], -1)), _createElementVNode("div", _hoisted_1, [__props.item ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, _toDisplayString(__props.item.description), 1), _createElementVNode("p", _hoisted_4, "提交人：" + _toDisplayString(__props.item.contactName), 1)])) : _createCommentVNode("", true), _createElementVNode("div", null, [_cache[1] || (_cache[1] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "选择处理人", -1)), _createVNode(UserSelector, {
            modelValue: selectedUserId.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectedUserId.value = $event),
            placeholder: "请选择处理人"
          }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("button", {
            onClick: handleClose,
            class: "px-5 py-2.5 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer"
          }, " 取消 "), _createElementVNode("button", {
            onClick: handleConfirm,
            disabled: !selectedUserId.value || loading.value,
            class: "px-5 py-2.5 bg-primary-700 text-white rounded-lg hover:bg-primary-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors cursor-pointer"
          }, _toDisplayString(loading.value ? '分配中...' : '确认分配'), 9, _hoisted_6)])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })]);
    };
  }
};